type UseShouldShowBlankPageQuickActions = {
	contentType: string;
	collabEditInitialized: boolean;
	isEditorEmpty: boolean;
	viewMode?: boolean;
};

export const useShouldShowBlankPageQuickActions = ({
	collabEditInitialized,
	contentType,
	isEditorEmpty,
	viewMode,
}: UseShouldShowBlankPageQuickActions) => {
	return contentType === 'page' && !viewMode && collabEditInitialized && isEditorEmpty;
};
